import { IconBase, IconComponent } from './BaseIcon';

export const MultiSelectRemove: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M27.3 2.49H13.24a2.57 2.57 0 00-2.57 2.57v1.79H6.73a1.67 1.67 0 00-1.67 1.67v20a1.67 1.67 0 001.67 1.68h15a1.67 1.67 0 001.67-1.67v-2.09h3.9a2.57 2.57 0 002.57-2.57V5.06a2.57 2.57 0 00-2.57-2.57zM21.36 28.2H7.06V8.85h14.3zm6.51-4.33a.57.57 0 01-.57.57h-3.94V8.52a1.67 1.67 0 00-1.67-1.67h-9V5.06a.57.57 0 01.57-.57H27.3a.57.57 0 01.57.57z" />
    <path d="M8.043 17.583h12.335v1.542H8.043z" />
  </IconBase>
);
